export interface RetrieveProductsResponse {
  name: string;
  productId?: string;
  productNumber?: number;
  fastTrackEnabled?: boolean;
  hideBundleType?: boolean;
}
